import React, { useState } from "react";
import { withRouter } from "react-router-dom";

function Card(props) {
  const { d, selectedProducts } = props;
  const [isSelected, setisSelected] = useState(selectedProducts.includes(d.id));
  return (
    <div
      // to={{
      //   pathname: `/products/${d.id}`,
      //   state: d,
      // }}
      key={d.id}
      className="card"
      style={{ padding: "unset" }}
    >
      <div
        style={{
          backgroundImage: `url(${d.image})`,
          height: "60px",
          backgroundPosition: "center",
          backgroundSize: "contain",
          borderRadius: "16px",
          backgroundRepeat: "no-repeat",
        }}
      />
      <div style={{ padding: "16px" }}>
        <input id={`id_${d.id}`} value={d.id} hidden onChange={() => {}} />
        <div>{d.title && d.title.substring(0, 25)}</div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <button
            className="icon"
            onClick={() => {
              var copyText = document.querySelector(`#id_${d.id}`);
              copyText.select();
              document.execCommand("copy");
            }}
          >
            C
          </button>
          <button
            className="icon"
            style={{
              backgroundColor: isSelected ? "var(--green)" : "white",
            }}
            onClick={() => {
              try {
                if (isSelected) {
                  const index = selectedProducts.indexOf(d.id);
                  selectedProducts.splice(index, 1);
                } else {
                  selectedProducts.push(d.id);
                }
                setisSelected(!isSelected);

                window.localStorage.setItem(
                  "SP",
                  JSON.stringify(selectedProducts)
                );
              } catch (error) {}
            }}
          >
            S
          </button>
          <button
            className="icon"
            onClick={() => {
              var copyText = document.querySelector(`#id_${d.id}`);
              copyText.select();
              document.execCommand("copy");
            }}
          >
            E
          </button>
        </div>
      </div>
    </div>
  );
}
export default withRouter(Card);
